import { render, staticRenderFns } from "./marketing-preferences.vue?vue&type=template&id=579c0f12&scoped=true"
import script from "./marketing-preferences.vue?vue&type=script&lang=ts"
export * from "./marketing-preferences.vue?vue&type=script&lang=ts"
import style0 from "./marketing-preferences.vue?vue&type=style&index=0&id=579c0f12&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579c0f12",
  null
  
)

export default component.exports